import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        component: () => import('../views/main.vue'),
        children: [{
                meta: {
                    // title: '西湖论剑·网络安全大会 构建安全可信的数字世界',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: false,
                    keepAlive:false,
                    ad_bottom_position: "",
                },
                path: "/",
                name: "home.home.index",
                component: () => import('../views/home/index.vue'),
            },
            {
                meta: {
                    // title: '西湖论剑 _ 一站式多云安全及多云管理服务平台 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: false,
                    ad_bottom_position: "",
                },
                path: "/mobile",
                name: "home.home.mobile",
                component: () => import('../views/home/mobile.vue'),
            },
            {
                meta: {
                    // title: '网络安全大会介绍_网络安全会议介绍 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:'网络安全大会介绍,网络安全会议介绍,互联网安全大会介绍,互联网安全会议介绍',
                    description:'西湖论剑网络安全大会将迎来十周年纪念,已然成为中国网络信息安全领域的一张金名片',
                    auth: false,
                    ad_bottom_position: "pc_about_bottom_banner",
                },
                path: "/about",
                name: "home.about.index",
                component: () => import('../views/about/index.vue'),
            },
            {
                meta: {
                    // title: '网络安全大会议程_网络安全大会日程_网络安全大会时间安排 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords: '网络安全大会议程,网络安全大会日程,网络安全大会时间安排',
                    description:'西湖论剑网络安全大会将于5月14日开幕,为期2天,包含一个主论坛及13个分论坛',
                    auth: false,
                    ad_bottom_position: "pc_meetings_bottom_banner",
                },
                path: "/meetings",
                name: "home.meetings.index",
                component: () => import('../views/meetings/index.vue'),
            },
            {
                meta: {
                    // title: '网络安全生态企业 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:'网络安全产业生态,网络安全行业生态,网络安全企业生态',
                    description:'网络安全生态圈,汇聚顶尖网络安全生态企业',
                    auth: false,
                    ad_bottom_position: "pc_ecology_bottom_banner",
                },
                path: "/ecology",
                name: "home.ecology.index",
                component: () => import('../views/ecology/index.vue'),
            },
            {
                meta: {
                    // title: '网络安全产品中心 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:'网络安全产品,运维审计系统,堡垒机,日志审计系统,web应用防火墙,数据库审计系统',
                    description:'安恒信息拥有云安全,数据安全,应用安全,物联网安全等各类安全产品',
                    auth: false,
                    ad_bottom_position: "pc_products_bottom_banner",
                },
                path: "/products",
                name: "home.products.index",
                component: () => import('../views/products/index.vue'),
            },
            {
                meta: {
                    // title: '网络安全大会报名指南_网络安全大会参会须知 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:'网络安全大会报名指南,网络安全大会参会须知',
                    description:'了解西湖论剑网络安全大会报名方式及参会须知',
                    auth: false,
                    ad_bottom_position: "pc_guide_bottom_banner",
                },
                path: "/guide",
                name: "home.guide.index",
                component: () => import('../views/guide/index.vue'),
            },
            {
                meta: {
                    // title: '网络安全大会媒体报导_网络安全大会新闻报导 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:'网络安全大会媒体报导,网络安全大会新闻报导',
                    description:'网络安全大会实时报导,及时了解大会动态',
                    auth: false,
                    ad_bottom_position: "pc_medias_bottom_banner",
                },
                path: "/news",
                name: "home.news.index",
                component: () => import('../views/news/index.vue'),
            },
            {
                meta: {
                    // title: '媒体报道 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:'网络安全大会媒体报导,网络安全大会新闻报导',
                    description:'网络安全大会实时报导,及时了解大会动态',
                    auth: false,
                    ad_bottom_position: "pc_medias_bottom_banner",
                },
                path:"/news/:id(\\d+)",
                name: "home.news.show",
                component: () => import('../views/news/show.vue'),
            },
            {
                meta: {
                    // title: '媒体报道 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: false,
                    ad_bottom_position: "pc_medias_bottom_banner",
                },
                path:"/news/link/:link",
                name: "home.news.link",
                component: () => import('../views/news/link.vue'),
            },
            {
                meta: {
                    // title: '直播-西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: false,
                    ad_bottom_position: "",
                },
                path:"/lives/:id(\\d+)",
                name: "home.lives.show",
                component: () => import('../views/lives/show.vue'),
            },
            {
                meta: {
                    // title: '直播-2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: false,
                    ad_bottom_position: "",
                },
                path:"/lives/watch",
                name: "home.lives.watch",
                component: () => import('../views/lives/watch.vue'),
            },
            {
                meta: {
                    // title: '我的预约 点亮地图 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: true,
                    ad_bottom_position: "",
                },
                path:"/infocenter/subscribe",
                name: "home.infocenter.subscribe",
                component: () => import('../views/infocenter/subscribe.vue'),
            },
            {
                meta: {
                    // title: '网络安全大会嘉宾介绍 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:'网络安全大会嘉宾,网络安全大会委员',
                    description:'西湖论剑网络安全大会邀请国内外顶级安全专家学者参会',
                    auth: false,
                    ad_bottom_position: "pc_guests_bottom_banner",
                },
                path: "/guests",
                name: "home.guests.index",
                component: () => import('../views/guests/index.vue'),
            },
            {
                meta: {
                    // title: '用户注册-2022 西湖论剑 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: false,
                    ad_bottom_position: "",
                },
                path: '/basics/register/:uuid',
                name: "basics.signin.register",
                component: () => import('../views/basics/register.vue'),
            },
            {
                meta: {
                    // title: '分享页面',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"分享页面",
                    description:'分享页面',
                    auth: true,
                    ad_bottom_position: "",
                },
                path: '/share',
                name: "share.index",
                component: () => import('../views/share/index.vue'),
            },
            {
                meta: {
                    // title: '西湖论剑网站隐私条款及用户协议 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: false,
                    ad_bottom_position: "",
                },
                path: '/basics/privacy',
                name: "basics.privacy.index",
                component: () => import('../views/basics/privacy.vue'),
            },
            {
                meta: {
                    // title: '西湖论剑网站服务条款 - 2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: false,
                    ad_bottom_position: "",
                },
                path: '/basics/clause',
                name: "basics.privacy.clause",
                component: () => import('../views/basics/clause.vue'),
            },
            {
                meta: {
                    // title: '10个院士共贺十年-2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: false,
                    ad_bottom_position: "",
                },
                path: '/channel/congratulate',
                name: "home.congratulate.index",
                component: () => import('../views/channel/congratulate.vue'),
            },
            {
                meta: {
                    // title: '访谈视频-2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: false,
                    ad_bottom_position: "pc_interview_bottom_banner",
                },
                path: '/channel/interview',
                name: "home.interview.index",
                component: () => import('../views/channel/interview.vue'),
            },
            {
                meta: {
                    // title: '访谈视频-2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: true,
                    ad_bottom_position: "",
                },
                path: '/channel/lives/:id(\\d+)',
                name: "home.channel.lives.show",
                component: () => import('../views/channel/livesShow.vue'),
            },
            {
                meta: {
                    // title: '研究成果-2022 西湖论剑',
                    title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                    keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                    description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                    auth: false,
                    ad_bottom_position: "pc_achievement_bottom_banner",
                },
                path: '/channel/achievement',
                name: "home.channel.achievement",
                component: () => import('../views/channel/achievement.vue'),
            },

        ]
    },
    {
        meta: {
                // title: '用户注册-2022 西湖论剑 - 2022 西湖论剑',
                title: '西湖论剑·浙江杭州网络安全大会举行 构建安全可信的数字世界',
                keywords:"网络安全论坛,网络安全大会,网络安全会议,物联网安全大会,互联网安全论坛,互联网安全大会,互联网安全会议",
                description:'西湖论剑网络安全大会汇聚国内外网络信息安全领域从业者,为中国网络信息安全事业发展建言献策',
                 auth: false,
        },
        path: '/basics/mobile/register/:uuid',
        name: "basics.basics.mobile",
        component: () => import('../views/basics/register.vue'),
    },
    {
        path: "*",
        redirect:'/',
    }
]

const router = new VueRouter({
    mode: "history",
    routes
})

export default router
